// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6346":"VoltoFormBlockEdit","6454":"Widgets","6821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6346":"7a0f2bfa","6454":"62da82f2","6821":"f7655845","7051":"62da82f2"}[chunkId] + ".chunk.css";
};